<template>
  <div>
    <mt-header title="实名认证" style="position:fixed;top:0;width:100%;z-index:1000;">
      <div @click="$router.go(-1)" slot="left">
        <mt-button icon="back"></mt-button>
      </div>
    </mt-header>
    <div style="padding:10px;text-align:center;">
      <div class="soSorry">很遗憾，实名认证申请失败！</div>
      <div class="youCan">您可以<span @click="recertification">重新实名认证</span></div>
      <div class="next">
        <van-button type="info" @click="recertification">重新认证</van-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'realNameFailed',
  created(){
    this.$emit('footer', false);
  },
  methods:{
    recertification(){
      this.$router.push({path:'/realName'})
    },
  }
}
</script>
<style scoped>
.soSorry{
  color: red;
  font-weight: bold;
  font-size: 22px;
  margin-top: 16vh;
}
.youCan{
  margin: 20px 0 100px;
  font-size: 18px;
}
.youCan span{
  color: red;
}
/* 按钮 */
.next{
    text-align:center;
    background:#fff;
    width:100%;
    padding:10px 0;
}
.next .van-button{
    width:60%;
    height:37px;
    border-radius: 5px;
    color:#fff;
}
</style>



// WEBPACK FOOTER //
// realNameFailed.vue?0d5f3b3c